import { render, staticRenderFns } from "./ReportGenerated.vue?vue&type=template&id=6bf2753a&lang=pug&"
import script from "./ReportGenerated.vue?vue&type=script&lang=ts&"
export * from "./ReportGenerated.vue?vue&type=script&lang=ts&"
import style0 from "./ReportGenerated.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports